import { HostSeatErrors } from "./constants";

const hostSeatErrorMap = new Map<string, string>([
  [HostSeatErrors.HOST_SEAT_NOT_FOUND, "server:host.seat.already.occupied"],
  [HostSeatErrors.SEAT_NOT_FOUND, "server:table.full"],
]);

const getErrorMessage = (reason: string): string =>
  hostSeatErrorMap.get(reason) ?? "server:table.unhandled";

export default getErrorMessage;
